import { Slot } from "@radix-ui/react-slot";

import { cn } from "./utils";

function Skeleton({
  asChild,
  className,
  ...props
}: React.ComponentProps<"div"> & {
  asChild?: boolean | undefined;
}) {
  const Comp = asChild ? Slot : "div";

  return (
    <Comp
      data-slot="skeleton"
      className={cn("bg-foreground/50 animate-pulse rounded-md", className)}
      {...props}
    />
  );
}

export { Skeleton };
